// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comm-users .history-row {
  margin: 3.125rem 0;
}
.comm-users .history-row h5 {
  font-size: 1.125rem;
  text-align: center;
  font-weight: bold;
  letter-spacing: 0.313rem;
  margin-bottom: 0;
}
.comm-users h4 {
  text-align: left !important;
  margin-bottom: 1.875rem;
}
.comm-users .by-month h3 {
  margin-bottom: 0 !important;
}
.comm-users .by-month {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3.75rem;
}
.comm-users-product {
  width: 90%;
  margin: 3.75rem auto;
  padding-top: 3.75rem;
}

/* ------------------------------------------------------ */
.comm-users .product-search {
  display: flex;
  align-items: center;
}
.comm-users .product-search button {
  border-radius: 0 !important;
}
.comm-users h2 {
  letter-spacing: 0.125rem;
  text-align: center;
  margin: 2.5rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/commUsers.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".comm-users .history-row {\n  margin: 3.125rem 0;\n}\n.comm-users .history-row h5 {\n  font-size: 1.125rem;\n  text-align: center;\n  font-weight: bold;\n  letter-spacing: 0.313rem;\n  margin-bottom: 0;\n}\n.comm-users h4 {\n  text-align: left !important;\n  margin-bottom: 1.875rem;\n}\n.comm-users .by-month h3 {\n  margin-bottom: 0 !important;\n}\n.comm-users .by-month {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 3.75rem;\n}\n.comm-users-product {\n  width: 90%;\n  margin: 3.75rem auto;\n  padding-top: 3.75rem;\n}\n\n/* ------------------------------------------------------ */\n.comm-users .product-search {\n  display: flex;\n  align-items: center;\n}\n.comm-users .product-search button {\n  border-radius: 0 !important;\n}\n.comm-users h2 {\n  letter-spacing: 0.125rem;\n  text-align: center;\n  margin: 2.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
